import { Form, Head } from "@inertiajs/react";
import { Input, Button, Checkbox } from "antd";
import { useState } from "react";

import LoginLayout from "@/components/layouts/LoginLayout";
import DeviceUserCard from "@/components/DeviceUserCard";

interface AdminLoginProps {
  csrf_token: string;
}

export default function AdminLogin({ csrf_token }: AdminLoginProps) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  return (
    <LoginLayout title="AVA Platform Login">
      <Head title="Admin Login" />
      <DeviceUserCard title="Login to your account">
        <Form
          action="/login"
          method="post"
          onSuccess={() => {
            setLoading(false);
          }}
          onError={() => {
            setLoading(false);
          }}
          onSubmit={() => setLoading(true)}
        >
          <input type="hidden" name="authenticity_token" value={csrf_token} />

          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <Input
              id="email"
              name="user[email]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="ant-input w-full"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <Input.Password
              id="password"
              name="user[password]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="ant-input-password w-full"
              placeholder="Enter your password"
              required
            />
          </div>

          <div className="flex justify-between items-center mt-4">
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="ant-checkbox"
            >
              Remember me
            </Checkbox>
            <input
              type="hidden"
              name="user[remember_me]"
              value={rememberMe ? '1' : '0'}
            />
            <a className="text-blue-500 no-underline text-sm" href="/password/new">
              Forgot your password?
            </a>
          </div>

          <div className="mt-4">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full text-white border-none rounded font-medium cursor-pointer mt-5 block"
              loading={loading}
            >
              Sign in
            </Button>
          </div>
        </Form>

        <div className="mt-4">
          <div className="flex items-center">
            <span className="flex-1 h-px bg-gray-200" />
            <span className="px-3 text-xs uppercase tracking-wide text-gray-400">or</span>
            <span className="flex-1 h-px bg-gray-200" />
          </div>
          <Button
            type="default"
            href="/login/otp"
            className="w-full mt-4 font-medium"
          >
            Send me an OTP to login
          </Button>
        </div>
      </DeviceUserCard>
    </LoginLayout>
  );
}
